import React from "react";
import { Modal } from "antd";
import "./styledModal.css";
import { CloseOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";

const StyledModal = ({
  isOpen,
  onClose,
  children,
  title = null,
  width,
  className = "",
}) => {

  const handleClose = (value, event) => {
    console.log("handleClose", value, event);
    onClose && onClose();
  };

  return (
    <Modal
      centered
      className={`styled-modal ${className}`}
      open={isOpen}
      onCancel={handleClose}
      title={title}
      width={width}
      footer={null}
    >
      {children}
    </Modal>
  );
};

export default StyledModal;
